import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';
import { BreakOnPipe } from '@pyg-pipes/break_on.pipe';

@Component({
  selector: 'app-vq-solve-problems',
  templateUrl: './vq-solve-problems.component.html',
  styleUrls: ['./vq-solve-problems.component.scss'],
  imports: [TranslatePipe, BreakOnPipe, LangRouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VgSolveProblemsComponent {
  public readonly problems = [
    { text: 'first', image: 'smile' },
    { text: 'second', image: 'watch' },
    { text: 'third', image: 'cloud' },
  ];
}
